function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("g", {
  transform: "translate(-.856 -.05)"
}, React.createElement("path", {
  d: "M17.334 22.814h-4.1M17.334 25.64h-7.145M17.334 28.465h-5.538"
})), React.createElement("g", {
  transform: "translate(19.346 19.14)"
}, React.createElement("ellipse", {
  cx: 14.721,
  cy: 13.039,
  rx: 1.601,
  ry: 1.591
}), React.createElement("ellipse", {
  cx: 4.334,
  cy: 13.039,
  rx: 1.601,
  ry: 1.591
}), React.createElement("path", {
  d: "M14.408 3.493h-2.577v9.546h1.328c0-1.203.703-1.591 1.6-1.591.899 0 1.602.388 1.602 1.59h1.171c.234 0 .43-.193.43-.426V7.645a.716.716 0 0 0-.078-.272l-3.007-3.725a.835.835 0 0 0-.469-.155zM.039.543v12.108c0 .233.195.427.43.427h2.264c0-1.203.703-1.553 1.601-1.553.86 0 1.562.35 1.601 1.553h5.896V.543a.432.432 0 0 0-.43-.427H.43C.234.116.039.31.039.543z"
})));

const SvgComponent = props => React.createElement("svg", _extends({
  width: 51,
  height: 51,
  viewBox: "0 0 51 51"
}, props), _ref);

export default __webpack_public_path__ + "static/media/icon-shipments-made.11755c8b.svg";
export { SvgComponent as ReactComponent };